<template>
	<div class="banner-split2-support-club">
		<b-row class="banner">
			<b-col class="col-lg-6 col-sm-12 col-12 left banner-item">
				<Slider :data="sliderData"></Slider>
			</b-col>
			<b-col class="col-lg-6 col-sm-12 col-12 right banner-item">
				<img class="club-pic" src="@/assets/support/text_puppet_club.png" alt="">
				<h3 class="title">會員辦法說明</h3>
				<p class="content">
					偶迷俱樂部是 利澤國際偶戲藝術村/無獨有偶劇團/偶寶貝劇團 共同的付費會員機制，只要加入俱樂部，便可享有此三個機構的好康喔！
				</p>
				<h3 class="title">Membership</h3>
				<p class="content">
					This is the united membership of Lìzé Puppet Art Colony, Puppet & Its Double Theatre and Oh Puppy Company. Submit the membership and you can get the benefit from the three companies.
				</p>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Slider from '@/components/slider'
export default {
  name: "bannerSplit2SupportClub",
  data() {
    return {
      sliderData: [
        "/static/assets/support/club/img_01.png",
      ]
    };
  },
  methods: {

  },
  props: {
    ch: String,
    en: String
  },
  components: {
    Slider
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .banner-split2-support-club
    text-align: justify
    overflow: hidden
    .banner
      .banner-item
        min-height: 480px
        height: 471px
        @media screen and (max-width: 1000px)
          height: initial
          min-height: 300px
      .left
        padding: 0
      .right
        background-color: $themeGray
        color: $white
        padding: 45px
        overflow-y: auto
        font-weight: 300
        .title
          font-size: $font-size-3
          margin: 20px 0
        .content
          font-size: $font-size-3-s
          line-height: 2
        .club-pic
          +size(318px, auto)

</style>



// WEBPACK FOOTER //
// src/components/banner/banner_split2_support_club.vue